//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import moment from 'moment-timezone';

export const createCountdownTimer = (
    countdownValue: number,
    countdownUnits: moment.unitOfTime.Diff,
): () => boolean => {
  const startTime = moment.now();
  return () => moment().diff(startTime, countdownUnits) >= countdownValue;
};
